import styled from "styled-components"

const lineColor = "rgb(200, 200, 200, 0.3)" // rgba(200,200,200,0.3)" //

export const TocHeader = styled.button`
  font-weight: 800;
  padding: 0;
  margin: 0;
  // text-transform: uppercase;
  // letter-spacing: 0.1em;
  > * {
    margin-right: 1em;
  }
  display: flex;
  justify-content: flex-start;
  flex-wrap: no-wrap;
  svg {
    display: block;
    position: relative;
  }
  cursor: ${(p) => (typeof p.onClick === "function" ? "pointer" : "default")};
  @media screen and (max-width: ${(p) => p.theme.breakpointMobile}) {
    width: 100%;
  }
`

interface ItemProps {
  isNumbered: boolean
  isMarked: boolean
}

export const TocListItem = styled.li<ItemProps>`
  display: block;
  margin: 0;
  &:not(:last-child) {
    margin-bottom: 0.5em;
  }
  &:not(.is-title) {
    counter-increment: custom-counter;
  }
  @media screen and (max-width: ${(p) => p.theme.breakpointMobile}) {
    margin-top: 0.5em;
  }

  &.is-title {
    display: none;
    button:before {
      display: none !important;
    }
  }
  .extra-column-item & {
    &.is-title {
      display: block;
      margin-bottom: 1em;
      font-size: 1rem;
      button {
        font-weight: 800;
      }
    }
  }
  button {
    width: 100%;
    text-align: left;
    font-weight: ${(p) => (p.isMarked ? 800 : 400)};
    // text-transform: uppercase;
    display: flex;
    &:before {
      display: ${(p) => (p.isNumbered ? "block" : "none")};
      content: counter(custom-counter) ". ";
      padding-right: 0.5em;
      text-align: right;
    }
  }
`

interface TocListProps {
  expanded: boolean
  onClick?: () => void
}

export const TocList = styled.ul<TocListProps>`
  margin: 0;
  padding: 0;
  transition: max-height 0.4s ease-in;
  overflow: hidden;
  width: 100%;
  max-height: ${(p) => (p.expanded ? "600px" : "105px")};
  @media screen and (max-width: ${(p) => p.theme.breakpointMobile}) {
    max-height: ${(p) => (p.expanded ? "600px" : "0px")};
  }
  cursor: ${(p) => (p.expanded ? "auto" : "pointer")};
  > * {
    pointer-events: ${(p) => (p.expanded ? "auto" : "none")};
  }
  position: relative;

  counter-reset: custom-counter;

  &:after {
    display: block;
    opacity: ${(p) => (p.expanded ? 0 : 1)};
    pointer-events: ${(p) => (p.expanded ? "none" : "auto")};
    transition: oppacity 0.4s ease-in;
    content: "";
    position: absolute;
    height: 50px;
    width: 100%;
    bottom: 0;
    // background-image: linear-gradient(to top, #fff, hsla(0, 0%, 100%, 0));
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
    .dark-mode & {
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0),
        ${(p) => p.theme.bgDark}
      );
    }
  }
`

interface TocWrapperProps {
  listOnly?: boolean
}

export const TocWrapper = styled.div<TocWrapperProps>`
  padding: 1em 0;
  @media screen and (max-width: ${(p) => p.theme.breakpointMobile}) {
    padding: 1em ${(p) => p.theme.paddingMobile} !important;
  }
  border-top: 1px solid ${lineColor};
  border-bottom: 1px solid ${lineColor};
  @media screen and (min-width: ${(p) => p.theme.breakpointMobile}) {
    > div {
      display: flex;
    }
  }
  ${(p) => (p.listOnly ? "border: none !important;" : "")}
  // padding-bottom: 0 !important;

  li {
    padding: ${(p) => (p.listOnly ? 0 : "0")};
  }

  font-size: ${(p) => p.theme.fontSizeSmall};
  .extra-column-item & {
    font-size: 1em;
  }

  &.toc-fixed-left {
    @media screen and (min-width: ${(p) => p.theme.breakpointTablet}) {
      max-width: calc(
        (100vw - ${(p) => p.theme.blockMaxWidthCentered}) / 2
      ) !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      margin-bottom: 0 !important;
      // height: 1px !important;
      overflow: show;
      left: 0;
      top: 50px;
      position: sticky;
      border: none;
      // border: 1px dashed red;
      height: calc(100vh - 50px);
      // margin-bottom: calc(-100vh + 50px);
      & + * {
        margin-top: calc(-100vh + 50px) !important;
      }

      > div {
        // border: 1px dashed green;
        max-width: 265px;
        margin: 0 auto;
        ${TocList} {
          max-height: none;
        }
        ${TocHeader} {
          display: none;
        }
        ${TocListItem} {
          border-bottom: none !important;
          margin: 0 0 2em 0;
          button {
            text-transform: none !important;
          }
        }
      }

      transition: opacity 0.3s ease-in-out;
      .scroll-trigger-in-view &,
      .on-deck & {
        opacity: 0;
        pointer-events: none;
      }
    }
    @media screen and (max-width: ${(p) => p.theme.breakpointTablet}) {
      margin-bottom: 3rem;
    }
  }
`
